module.exports = __webpack_public_path__ + "static/media/IMG_3326.289083f7.jpg";